import './styles.scss';
import { Col, Row, Button } from 'antd';
import { EditHeaderNavigation } from './editHeaderNavigation';
import { EditHeaderTopBar } from './editHeaderTopBar';
import { EditHeaderCta } from './editHeaderCta';
import { EditHeaderLogo } from './editHeaderLogo';

export default function EditWebsiteHeader() {
  return (
    <div className="edit-header">
      <div className="content">
        <Row gutter={12}>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <div className="card navigation">
              <div className="heading">
                <p className="label">Navigation</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="list">
                <div className="item">
                  <p className="label">Home</p>
                </div>
                <div className="item">
                  <p className="label">About Us</p>
                </div>
                <div className="item">
                  <p className="label">
                    Treatments <span>(Dropdown)</span>
                  </p>
                  <div className="dropdown">
                    <div className="column">
                      <p className="title">Column Title 1</p>
                      <div className="list">
                        <div className="item">
                          <p className="link">Dropdown link 1</p>
                        </div>
                        <div className="item">
                          <p className="link">Dropdown link 2</p>
                        </div>
                      </div>
                    </div>
                    <div className="column">
                      <p className="title">Column Title 2</p>
                      <div className="list">
                        <div className="item">
                          <p className="link">Dropdown link 1</p>
                        </div>
                        <div className="item">
                          <p className="link">Dropdown link 2</p>
                        </div>
                      </div>
                    </div>
                    <div className="column">
                      <p className="title">Column Title 3</p>
                      <div className="list">
                        <div className="item">
                          <p className="link">Dropdown link 1</p>
                        </div>
                        <div className="item">
                          <p className="link">Dropdown link 2</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <p className="label">Doctors</p>
                </div>
                <div className="item">
                  <p className="label">
                    Why Us <span>(Dropdown)</span>
                  </p>
                  <div className="dropdown">
                    <div className="column">
                      <p className="title">Column Title 1</p>
                      <div className="list">
                        <div className="item">
                          <p className="link">Dropdown link 1</p>
                        </div>
                        <div className="item">
                          <p className="link">Dropdown link 2</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <p className="label">Contact Us</p>
                </div>
              </div>
            </div>
            <EditHeaderNavigation />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="card topbar">
              <div className="heading">
                <p className="label">Top Bar</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="item">
                  <p className="label">Opening Hours:</p>
                  <p className="value">
                    Monday - Saturday : 10:30 AM - 7:00 PM, Thursday: Holiday,
                    Sunday: 10:30 AM - 1:00 PM
                  </p>
                </div>
                <div className="item">
                  <span className="label">Call: </span>
                  <span className="value">+91-9876543210</span>
                </div>
                <div className="item">
                  <span className="label">Show Topbar: </span>
                  <span className="value">Yes</span>
                </div>
              </div>
            </div>
            <EditHeaderTopBar />
            <div className="card logo">
              <div className="heading">
                <p className="label">Logo</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="image">
                  <img src="https://logos-world.net/wp-content/uploads/2020/04/Huawei-Logo-700x394.png" />
                </div>
              </div>
            </div>
            <EditHeaderLogo />
            <div className="card cta">
              <div className="heading">
                <p className="label">Call to Action Button</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="item">
                  <span className="label">Button Text: </span>
                  <span className="value">Book Appointment</span>
                </div>
                <div className="item">
                  <p className="label">On Click take user to Page/Link: </p>
                  <p className="value">Contact Us</p>
                  <p className="value">
                    https://dental-website-psi.vercel.app/home
                  </p>
                </div>
              </div>
            </div>
            <EditHeaderCta />
          </Col>
        </Row>
      </div>
    </div>
  );
}
